import React from "react";
import { useTheme } from "../theme/ThemeProvider";
import { MoonStar, Sun } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      className={
        "inline-flex items-center justify-center rounded-lg border w-9 h-9 text-sm " +
        "border-zinc-950/10 bg-white text-zinc-700 hover:bg-zinc-50 ml-0 " +
        "dark:border-zinc-300/10 dark:bg-zinc-800 dark:text-zinc-200 " +
        className
      }
      title={theme === "dark" ? "라이트 모드로" : "다크 모드로"}
    >
      {theme === "dark" ? (
        <>
          <Sun className="h-5 w-5" aria-hidden="true" />
        </>
      ) : (
        <>
          <MoonStar className="h-5 w-5" aria-hidden="true" />
        </>
      )}
    </button>
  );
}
